module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x25-c44fe0595cfc7964672d1c2c2c5e0534.png";